<div>
    <p>{{'aumico_admin_ar_template_specifications' | i18next }}</p>
</div>
<div class="aum-row">
    <div class="aum-col">
        <aum-input
            placeholder="{{ 'aumico_companies_form_placeholder_please_enter' | i18next  }}"
            [aumFormControl]="formGroup.controls['name']"
        >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_name' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['name'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-input>
    </div>
</div>
<div class="aum-row">
    <div class="aum-col">
        <aum-input
            placeholder="{{ 'aumico_companies_form_placeholder_please_enter' | i18next  }}"
            [aumFormControl]="formGroup.controls['caption']"
        >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_caption' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['caption'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-input>
    </div>
    <div class="aum-col">
        <aum-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [aumFormControl]="formGroup.controls['state']"
            [options]="stateOptions"
        >
            >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_state' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['state'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-select>
    </div>
</div>

<div class="aum-row">
    <div class="aum-col">
        <aum-draggable-multi-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [aumFormControl]="formGroup.controls['countries']"
            [options]="countries"
        >
            >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_countries' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['countries'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-draggable-multi-select>
    </div>
    <div class="aum-col">
        <aum-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [aumFormControl]="formGroup.controls['consistency']"
            [options]="consistencyOptions"
        >
            >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_consistency' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['state'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-select>
    </div>
</div>

<div class="aum-row">
    <div class="aum-col">
        <aum-draggable-multi-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [aumFormControl]="formGroup.controls['legalForms']"
            [options]="legalFormsOptions"
        >
            >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_legal_forms' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['legalForms'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-draggable-multi-select>
    </div>
    <div class="aum-col">
        <aum-draggable-multi-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [options]="accountingBasesOptions"
            [aumFormControl]="formGroup.controls['accountingBasis']"
        >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_accounting_bases' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['accountingBasis'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-draggable-multi-select>
    </div>
</div>

<div class="aum-row">
    <div class="aum-col">
        <aum-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [aumFormControl]="formGroup.controls['businessModel']"
            [options]="businessModelsOptions"
        >
            >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_business_models' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['businessModel'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-select>
    </div>
    <div class="aum-col">
        <aum-draggable-multi-select
            placeholder="{{ 'aumico_companies_form_placeholder_please_select' | i18next  }}"
            [aumFormControl]="formGroup.controls['locales']"
            [options]="localesOptions"
        >
            >
            <aum-form-field-label>
                {{ 'aumico_admin_ar_template_general_information_locales' | i18next }}
            </aum-form-field-label>
            <aum-form-error *ngIf="formGroup.controls['locales'].hasError('required')">
                {{ 'aumico_admin_ar_template_general_information_field_required_error' | i18next }}
            </aum-form-error>
        </aum-draggable-multi-select>
    </div>
</div>

<div style="margin-bottom: 16px; margin-top: 20px">
    {{ 'aumico_admin_ar_template_general_information_annual_report_steps' | i18next }}
</div>
<div>
    <app-drag-drop-component
        [sections]="defaultAnnualReportSteps"
        [orderedSections]="annualReportSavedDragAndDropItems"
        (draggedOrderedSections)="onReportStepsChanged($event)"
    ></app-drag-drop-component>
</div>
